import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";
import ServiceMember from "./ServiceMember";

export default class MemberUserService extends ServiceMember {
    constructor() {
        super();
        this.baseURL = 'security/user/member';
    }

    async changeUserPassword(password) {
        let data = {
            "password" : password
        };
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/password/change" , {
            crossDomain: true,
            method: 'put',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findUser() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL, {
            headers: {'Content-Type': 'application/json'},
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }



}